module.exports = __webpack_public_path__ + "img/weddingbands.fe5dc6e.png";